<script src="../main.js"></script>
<template>
  <div>
    <div class="header">
      <Header></Header>
    </div>
    <div class="conference">
      <confenrence></confenrence>
    </div>
    <div class="previous">
      <previous2></previous2>
    </div>

<!--    <div >-->
<!--      <Footer></Footer>-->
<!--    </div>-->
  </div>
</template>

<script>
export default {
  name: 'Home',
  data(){
    return{

    }
  }

}
</script>
<style lang="less" scoped>
</style>
